import React from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import DataProductTable from "../../components/Data-product-table/DataProductTable";
import { cardIconSx, clientListThemeVars } from "../../theme/globalStyle/globalStyle";
import './product-list.css';
require('firebase/auth')

function ProductList(){

    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)
    const canCreateProduct = user?.permissoes?.product?.isCreate || user?.permissoes?.produto?.cadastrar;

    return(
        <>
            {
                userLogado > 0 ?
                    <NewMiniDrawer divOpen={
                        <Box className="product-list-page" sx={pageWrapperSx} style={clientListThemeVars}>
                            <Card sx={heroCardSx}>
                                <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                                    <Box className="product-list-hero">
                                        <Stack spacing={1} className="product-list-hero-copy">
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Box sx={cardIconSx}>
                                                    <Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />
                                                </Box>
                                                <Typography sx={heroTitleSx}>Precificação</Typography>
                                            </Box>
                                            <Typography sx={heroSubtitleSx}>
                                                Consulte, filtre e mantenha os produtos usados nas operacoes comerciais e de transporte.
                                            </Typography>
                                        </Stack>

                                        {
                                            canCreateProduct ? (
                                                <Button
                                                    component={Link}
                                                    to="/product"
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    sx={primaryActionSx}
                                                >
                                                    Novo produto
                                                </Button>
                                            )
                                            : (
                                            ""
                                            )
                                        }
                                    </Box>
                                </CardContent>
                            </Card>

                            <Card sx={contentCardSx}>
                                <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                                    <Box className="product-list-table-heading">
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Box sx={cardIconSx}>
                                                <TableRowsOutlinedIcon sx={{ color: "#ffffff" }} />
                                            </Box>
                                            <Box>
                                                <Typography sx={sectionTitleSx}>Lista de produtos</Typography>
                                                <Typography sx={sectionSubtitleSx}>Use os filtros das colunas para localizar registros especificos.</Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box className="product-list-table-shell">
                                        <DataProductTable />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                }/>
                :
                <Navigate to='/login' />
            }
        </>
    );
}

export default ProductList;

const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-soft)",
};

const contentCardSx = {
    borderRadius: "var(--client-radius-lg)",
    border: "1px solid var(--client-primary-border)",
    boxShadow: "var(--client-shadow-table)",
    background: "var(--client-surface-soft)",
};

const heroTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const sectionTitleSx = {
    color: "var(--client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--client-primary-hover)",
    },
};
